export class LoteDetalhesDto {
  id: number;
  label: string;
  coords: number[][];
  centro: number[];
  quadra: string;
}
